module.exports = __webpack_public_path__ + "static/govtech-logo-3e6a4eb1eba3366f6a539fe61cd4b7a8.gif";